import { makeApiRequest } from "../components/utils";
import { useMutation, useQuery } from "@tanstack/react-query";
import { VALID_VENDOR_SEARCH_JOB_NAMES } from "../constants/queueConstants";
const getVendors = async (props) => {
  const searchQuery = new URLSearchParams(props);
  const hasQuery = searchQuery.toString() !== "";

  return makeApiRequest({
    endpoint: `/api/vendors${hasQuery ? `?${searchQuery.toString()}` : ""}`,
    method: "GET"
  });
};

export const useVendors = (props) => {
  return useQuery(
    [
      "VENDORS",
      props.search,
      props.limit,
      props.tags?.join(",") ?? ""
    ],
    () => getVendors(props),
    {
      cacheTime: 0,
      enabled: props.enabled ?? true
    }
  );
};

const getVendor = async (vendorId) => {
  return makeApiRequest({
    endpoint: `/api/vendors/${vendorId}`,
    method: "GET"
  });
};

const getVendorTransactions = async (vendorId) => {
  return makeApiRequest({
    endpoint: `/api/vendors/${vendorId}/transactions`,
    method: "GET"
  });
};

export const useVendorTransactions = (vendorId) => {
  return useQuery({
    queryKey: ["VENDOR_TRANSACTIONS", vendorId],
    queryFn: () => getVendorTransactions(vendorId),
    enabled: !!vendorId,
    staleTime: 30000,
    cacheTime: 5 * 60 * 1000
  });
};

export const useVendorMutation = () => {
  return useMutation(async ({ vendorId, update }) => {
    return makeApiRequest({
      endpoint: `/api/vendors${vendorId ? `/${vendorId}` : ""}`,
      method: "PUT",
      body: update,
      json: true
    });
  });
};

export const useStartVendorMemoTester = () => {
  return useMutation({
    mutationFn: async ({ vendorId, pattern }) => {
      const response = await makeApiRequest({
        endpoint: "/api/vendors/start-vendor-job",
        method: "POST",
        body: {
          jobData: {
            jobName: VALID_VENDOR_SEARCH_JOB_NAMES.START_MEMO_TESTER,
            vendorId,
            pattern
          }
        },
        json: true
      });
      if (response.error) {
        throw new Error(response.error);
      }
      return response;
    }
  });
};

export const useGetMatchedMemos = (vendorId) => {
  return useQuery({
    queryKey: ["matchedMemos", vendorId],
    queryFn: async () => {
      const response = await makeApiRequest({
        endpoint: `/api/vendors/${vendorId}/matched-memos`,
        method: "GET"
      });
      return response;
    },
    enabled: !!vendorId,
    staleTime: 30000,
    cacheTime: 5 * 60 * 1000
  });
};

export const useUpdateVendorEnhancements = (vendorId) => {
  return useMutation(async (update) => {
    return makeApiRequest({
      endpoint: `/api/vendors/${vendorId}/enhance`,
      method: "PUT",
      body: update,
      json: true
    });
  });
};

export const useVendor = (id, options = {}) =>
  useQuery(["VENDOR", id], () => getVendor(id), {
    cacheTime: 0,
    ...options
  });
